import { PUBLIC_DIV_MODAL, PUBLIC_IFRAME_MODAL } from "./constants";
import PublicDivModal from "./PublicDivModal";
import PublicIFrameModal from "./PublicIFrameModal";

export default [
  [PUBLIC_DIV_MODAL, PublicDivModal],
  [PUBLIC_IFRAME_MODAL, PublicIFrameModal]
];
